import { translate } from '@/translation/translate.ts';
import SignatureCanvas from 'react-signature-canvas';
import { FC, useEffect, useRef } from 'react';
import { Slide as SlideType } from '@/eventConfig/types.ts';
import { Slide } from '../Slide';
import { useEventConfig } from '@/eventConfig/useEventConfig';
import moment from 'moment';
import { useForm } from '@/form/useForm.ts';

interface SignpadSlideProps {
  className?: string;
  slide: SlideType;
}

export const SignpadSlide: FC<SignpadSlideProps> = (props) => {
  const { slide } = props;
  const { eventConfig } = useEventConfig();
  const canvas = useRef<SignatureCanvas>(null);
  const { onChange, getFieldValue } = useForm();

  useEffect(() => {
    const signatureFormData = getSignatureFromData();
    if (signatureFormData && canvas.current) {
      canvas.current.fromDataURL(`${signatureFormData}`);
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  const getSignatureFromData = () => {
    return getFieldValue('signature', 'raw') ?? null;
  };

  const onEndStroke = async () => {
    const signature = {
      raw: canvas.current?.toDataURL('image/png') ?? '',
      normalized: canvas.current?.toDataURL('image/png') ?? '',
    };

    const date = {
      raw: moment().format('YYYY-MM-DD'),
      normalized: moment().format('YYYY-MM-DD'),
    };

    onChange('signature', { value: signature, isValid: true, hint: undefined, slideId: slide.id });
    onChange('signatureDate', { value: date, isValid: true, hint: undefined, slideId: slide.id });
  };

  const onClearCanvas = () => {
    canvas.current?.clear();
    onChange('signature', null);
    onChange('signatureDate', null);
  };

  // React is unhappy with the typing of this third party component, no other
  // way to make it behave.
  const SignatureCanvasComponent = SignatureCanvas as unknown as any;

  return (
    <Slide {...props} className="type-signpad">
      <div className="signpad-wrap">
        <SignatureCanvasComponent
          canvasProps={{ className: 'signatureCanvas' }}
          penColor="#2c5a82"
          ref={canvas}
          onEnd={onEndStroke}
          clearOnResize={false}
        ></SignatureCanvasComponent>
        <button className="clear" onClick={onClearCanvas}>
          <i className="fas fa-times-circle" />
          {translate(eventConfig?.translations.clear)}
        </button>
      </div>
      <i className="fas fa-pen signpad-pen" />
    </Slide>
  );
};
